export default __webpack_public_path__ + "static/media/transaction-failed-cross.5688e9ac.svg";